import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=a9d99e2a&scoped=true&"
import script from "./InfoPopup.vue?vue&type=script&lang=js&"
export * from "./InfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=a9d99e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d99e2a",
  null
  
)

export default component.exports